import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  headerAuthWrapper: {
    '&.hidden': {
      visibility: 'hidden'
    }
  },
  headerAuthLink: {
    marginRight: theme.spacing(1),
    padding: theme.spacing(0, 1),
    display: 'inline-block',
    fontSize: theme.typography.pxToRem(20),
    color: theme.palette.primary.main,
    position: 'relative',
    verticalAlign: 'initial',
    backgroundColor: 'transparent !important',
    '&:not(:last-of-type):before': {
      content: '""',
      height: '60%',
      right: theme.spacing(-0.5),
      top: 0,
      bottom: 0,
      margin: 'auto',
      position: 'absolute',
      borderRight: '1px solid'
    }
  },
  AnonymousContainer: {
    display: 'flex !important',
    minHeight: 'calc( 100vh - 78px )',
    height: 'calc( 100vh - 78px )',
    paddingTop: 64,
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },
  AnonymousWidget: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: theme.typography.pxToRem(20),
    [theme.breakpoints.up('xs')]: {
      minWidth: 325
    },
    '& p': {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(0)
    }
  },
  adminSectionContainer: {
    margin: theme.spacing(1.5),
    '&:hover': {
      boxShadow: '0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12)'
    }
  }
}))
